import { lazy } from "react";
import { withPageLoader } from "@tecorien/mimic-v2";
import { links } from "links";
import { getCreatePathTemplate } from "navigation";
import { RouteDescription } from "types";

const GenerateFilePage = lazy(() => import("./GenerateFilePage"));

export const generateFileRoutes: RouteDescription[] = [
  {
    path: getCreatePathTemplate(links.generateFile),
    element: withPageLoader(<GenerateFilePage />),
    breadcrumb: "Generate File",
  },
];

